import english from './en';
import spanish from './es';
import portuguese from './pt';

export const en = {
    name: 'en',
    messages: { "en": english }
}
export const es = {
    name: 'es',
    messages: { "es": spanish }
}

export const pt = {
    name: 'pt',
    messages: { "pt": portuguese }
}

export const languages = [
    en,
    es,
    // pt,
]


// WEBPACK FOOTER //
// ./src/lang/languages.js